module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pass_white.08ed7e89.svg";